import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  getCompanyLogo,
} from "../../../utils/utils.common";
import { sweetAlert } from "../../../utils/swal";
import { downloadBase64File } from "../../../utils/pdf-downloader";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { FleetService } from "../fleet-service/fleet.service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ParserService } from "../../broker-parser/planner-service/parser-service";
import { promise } from "protractor";
import { CsvService } from "src/app/service/csv-service/csv.service";
import * as moment from 'moment-timezone';
import { StaffService } from "../../staffs/staff-service/staff.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
@Component({
  selector: "app-fleet-list",
  templateUrl: "./fleet-list.component.html",
  styleUrls: ["./fleet-list.component.css"],
})
export class FleetListComponent implements OnInit, OnDestroy {
  path = null;
  fleetList = [];
  search: any;
  status = "active";
  fundingSources: any=[];
  preFundingSources = {};
  selectedCorporateUser: any = null;
  user: any=[];
  userEmail=null;
  isFMS = false;
  timeZone: string = '';
  preStaffList = {};
  preServiceAreas = {};
  columnsSortOrder: any = {
    driver: '',
    setiDecall: '',
  }

  constructor(
    private fleetService: FleetService,
    private parserService:ParserService,
    private assignTripService: AssigTripsService,
    private activatedRoute: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private csvService: CsvService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
  ) {}

  ngOnInit() {
    this.getCorporateUserList();
    this.getUser()
    this.getStaffList();
    this.getServiceAreas();
  }

 getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          if (this.user.hasOwnProperty('isFMS') && this.user.isFMS) {
            this.isFMS = true;
          }
        }
      });
  }

  getFleetList() {
    this.fleetService
      .getCredentialedFleetList({'isFleetSection': true,'status': this.status})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.fleetList = data;
            const column = Object.keys(this.columnsSortOrder)
              .find(key => this.columnsSortOrder[key]);
            if (column) {
              this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
              this.sortColumn(column);
            }
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getCorporateUserList() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.fundingSources = data;
          this.preFundingSources = this.fundingSources.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.selectedCorporateUser = this.fundingSources.find((user) => user.isFMS) || this.fundingSources[0] || null;
        }
        this.getFleetList();
      });
  }

  onChangeStatus() {
    this. getFleetList()
  }

   onMoveToFMS() {
      if (this.user && this.user.hasOwnProperty('isFMS')) {
        if (this.user.isFMS) {

        this.loginToExternalApp(this.user.email);
        }
      }
    }


  getCompanyImage(driverCar) {
    return getCompanyLogo(driverCar);
  }

  downloadSingleFleetQR(fleetId) {
    this.fleetService.getSingleFleetQR(fleetId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  downloadAllFleetQR() {
    const data = {
      status: this.path,
    };
    this.fleetService.getAllFleetQR(data)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  // }

  // async loginToExternalApp(email) {
  //   try {
  //     // get or create fms broker config
  //     const nemtToken=JSON.parse(localStorage.getItem('token'))
  //     const res = await this.fleetService.getBrokerSettingList().toPromise();
  //     let fmsConfig = res.find(item => item.name === 'fms');

  //     const loginRes = await this.fleetService.externalLogin({
  //       ...this.user,
  //      token: fmsConfig && fmsConfig.orgId ? fmsConfig.orgId : null,
  //      fmsConfiguration:fmsConfig ? fmsConfig : null,
  //      nemtToken:nemtToken
  //     }).toPromise() as any;

  //     if (!loginRes.token) return;

  //     if (!fmsConfig) {

  //       fmsConfig = await this.parserService.addBrokerSetting({
  //         username:email,
  //         password: '123456',
  //         name: 'fms',
  //         orgId: loginRes.token
  //       }).toPromise();


  //     } else {
  //       fmsConfig = await this.parserService.updataBrokerSetting({
  //         ...fmsConfig,
  //         orgId: loginRes.token
  //       }).toPromise();


  //       this.fleetService.redirectToExternalApp(loginRes.token);

  //     }

  //   } catch (err) {
  //     sweetAlert('Error', err.message || 'Something went wrong', 'error', 'OK');
  //   }
  // }

  async loginToExternalApp(email:any) {
  try {
    const nemtToken=JSON.parse(localStorage.getItem('token'))
    const res = await this.fleetService.getBrokerSettingList().toPromise();
    let fmsConfig = res.find((item: any) => item.name === 'fms');
    const loginRes = await this.fleetService.externalLogin({
        ...this.user,
       token: fmsConfig && fmsConfig.orgId ? fmsConfig.orgId : null,
       fmsConfiguration:fmsConfig ? fmsConfig : null,
       nemtToken:nemtToken
      }).toPromise() as any;

    if (!loginRes.token) {
      sweetAlert('Error', 'Invalid credentials', 'error', 'OK');
      return;
    }

    if (fmsConfig && loginRes.signature && fmsConfig.orgId !== loginRes.signature) {
      try {
        await this.parserService.updataBrokerSetting({
          ...fmsConfig,
          orgId: loginRes.signature
        }).toPromise();
      } catch (e) {
        console.error('Failed to save FMS signature', e);
      }
    }

    this.fleetService.redirectToExternalApp(loginRes.token);
  } catch (err) {
    sweetAlert('Error', err || 'Something went wrong', 'error', 'OK');
  }
}

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
  }

  downloadCSV() {
    const data = {
      date: moment().tz(this.timeZone).format("MM-DD-YYYY"),
      fleetList: this.fleetList,
      preStaffList: this.preStaffList,
      preServiceAreas: this.preServiceAreas,
      timezone: this.timeZone
    };
    this.csvService.generateFleetReport(data);
  }


  sortColumn(column: string) {
    Object.keys(this.columnsSortOrder).forEach(col => {
      if (col !== column) {
        this.columnsSortOrder[col] = '';
      }
    })
    if (!this.columnsSortOrder[column]) {
      this.columnsSortOrder[column] = 'asc';
    } else {
      this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
    }

    this.fleetList.sort((a: any, b: any) => {
      let valA = a[column] || 0;
      let valB = b[column] || 0;

      if (column === 'driver') {
        valA = ((a && a.driver && a.driver.displayName) || '').toLowerCase();
        valB = ((b && b.driver && b.driver.displayName) || '').toLowerCase();
      }

      // handle string numbers safely
      if (!isNaN(valA)) valA = Number(valA);
      if (!isNaN(valB)) valB = Number(valB);

      if (valA < valB) return this.columnsSortOrder[column] === 'asc' ? -1 : 1;
      if (valA > valB) return this.columnsSortOrder[column] === 'asc' ? 1 : -1;

      return 0;
    });

  }

  ngOnDestroy(): void {
  }
}
